type Validator = {
    [key: string]: (value: any, obj?: any) => boolean;
};

const componentTypes = ['BUTTON', 'DIALOG', 'TOAST', 'DROPDOWN', 'MODAL'];

const commonUIFieldValidator: Validator = {
    'id': (data: any): boolean => typeof data === 'string',
    'type': (data: any): boolean => componentTypes.includes(data),
};

export const buttonConfigValidator: Validator = {
    ...commonUIFieldValidator,
    'location': (data: any): boolean => typeof data === 'string',
    'page': (data: any): boolean => typeof data === 'string'
};

export const dropDownConfigValidator: Validator = {
    ...buttonConfigValidator,
    'children': (data: any): boolean => Array.isArray(data) && data.every(item => typeof item === 'object')
};

export const dialogConfigValidator: Validator = {
    ...commonUIFieldValidator,
    options: (data: any): boolean => typeof data === 'object'
};

export const toastConfigValidator: Validator = {
    ...commonUIFieldValidator,
    message: (data: any): boolean => typeof data === 'string',
};


const checkModalFormDropdownFieldOptions = (config: any): boolean => {
    if(config.values && typeof config.values[0] ===  'object' && (config.type === 'SINGLE_ITEM' || config.type === 'MULTIPLE_ITEM')){
        return config.option_label && config.option_value;
    }
    return true;
};

const  checkModalConfigBasedOnDataType = (data: any): boolean => {
    if(data['dataType'] === 'IFRAME'){
        return data['url'] && typeof data['url'] === 'string';
    }else if(data['dataType'] === 'HTML'){
        return data['html'] && typeof data['html'] === 'string';
    }else if(data['dataType'] === 'DETAILS'){
        return data['data'] !== undefined;
    }else if(data['dataType'] === 'FORM'){
        return data['fields'] !== undefined && data['fields'].every((field: any)=> checkModalFormDropdownFieldOptions(field));
    }
};


export const modalConfigValidator: Validator = {
    ...commonUIFieldValidator,
    options: (data: any): boolean => ['DETAILS', 'IFRAME', 'FORM', 'HTML'].includes(data['dataType']) && checkModalConfigBasedOnDataType(data)
};

export const validateObject = (obj: Record<string, any>, validator: Validator): boolean => {
    const validations = {};
    const isValid = Object.keys(validator).every((key) => {
        if (key in obj) {
            validations[key] = validator[key](obj[key], obj);
            return validations[key];
        }
        // If there's no validator for the key, consider it valid (return false to stop `some` early)
        return false;
    });

    if (isValid) {
        return true;
    } else {
        console.log(obj, validator, validations);
        return false;
    }
};
